// @ts-check

class ReferralLinkErrors extends HTMLElement {
  connectedCallback() {
    try {
      const params = new URLSearchParams(window.location.search);
      const errorKey = params.get('error');

      if (!errorKey) return;

      const errorNodes = Array.from(this.querySelectorAll('[slot]'));
      const activeNode = /** @type {HTMLElement | undefined} */ (
        errorNodes.find((node) => node.slot === errorKey)
      );

      if (!activeNode) return;

      errorNodes.forEach((node) => {
        const el = /** @type {HTMLElement} */ (node);
        el.style.display = node === activeNode ? '' : 'none';
      });

      this.style.display = '';
    } catch (e) {
      console.error(e);
    }
  }
}

customElements.define('referral-link-errors', ReferralLinkErrors);
